// extracted by mini-css-extract-plugin
export default {"footer":"Footer-module__footer___R4F2J","footerNavigation":"Footer-module__footerNavigation___fT0v9","footerNavigationLink":"Footer-module__footerNavigationLink___zQmli"};